import app from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBrADi3b1M3nZtobPrJoeuDPDAZ2qoEUNk",
  authDomain: "eurovision-firebase.firebaseapp.com",
  databaseURL: "https://eurovision-firebase.firebaseio.com",
  projectId: "eurovision-firebase",
  storageBucket: "eurovision-firebase.appspot.com",
  messagingSenderId: "707269038984",
  appId: "1:707269038984:web:e78936128a7659a5ca203d",
  measurementId: "G-6FVJ9SNH3T"
};

class Firebase {
  constructor() {
    app.initializeApp(firebaseConfig);
    app.auth().setPersistence(app.auth.Auth.Persistence.LOCAL);
    this.auth = app.auth;
    this.firestore = app.firestore;
  }
}

export default new Firebase();
